import { render, staticRenderFns } from "./DashboardTeacher.vue?vue&type=template&id=349ec603&scoped=true"
import script from "./DashboardTeacher.vue?vue&type=script&lang=js"
export * from "./DashboardTeacher.vue?vue&type=script&lang=js"
import style0 from "./DashboardTeacher.vue?vue&type=style&index=0&id=349ec603&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ec603",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349ec603')) {
      api.createRecord('349ec603', component.options)
    } else {
      api.reload('349ec603', component.options)
    }
    module.hot.accept("./DashboardTeacher.vue?vue&type=template&id=349ec603&scoped=true", function () {
      api.rerender('349ec603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardTeacher.vue"
export default component.exports